<template>
  <div class="footer-module">
    <div class="footer-box">
      <!-- <div class="foot-banner">
        <a class="foot-banner-post" href="http://www.chinapost.com.cn/" target="_blank" title="中国邮政">
        </a>
        <a class="foot-banner-commitment" href="//www.ule.com/help/real.html" target="_blank" title="品质保障 优选邮乐">
        </a>
        <a class="foot-banner-free" href="//help.ule.com/helpcenter/64/4.html" target="_blank" title="覆盖城乡 安全速达">
        </a>
      </div> -->
      <div class="foot-helper">
        <ul class="clearfix">
          <li>
            <!-- <img src="https://i0.ulecdn.com/sites/ule/img/home/new/logo.png"> -->
            <div class="floor1">
              <img
                class="logo-yz"
                src="https://i0.ulecdn.com/sites/ule/img/home/new/icon_logo_yz.png"
                alt=""
              />
              <i></i>
              <img
                class="logo-ule"
                src="https://i0.ulecdn.com/sites/ule/img/home/new/icon_logo_ule.png"
                alt=""
              />
            </div>
            <p class="floor2">乡村振兴综合生态互联网平台</p>
            <div class="floor3">
              <div class="img-wraper">
                <img
                  src="https://i0.ulecdn.com/sites/ule/img/home/new/icon_ulevip.png"
                  alt=""
                />
                <div class="text">
                  <p>微信扫描二维码</p>
                  <p>关注公众号</p>
                </div>
              </div>
              <div class="img-wraper">
                <img
                  src="https://i0.ulecdn.com/sites/ule/img/home/new/icon_ule.png"
                  alt=""
                />
                <div class="text">
                  <p>扫描二维码</p>
                  <p>下载邮乐网APP</p>
                </div>
              </div>
              <div class="img-wraper">
                <img
                  src="https://i0.ulecdn.com/sites/ule/img/home/new/icon_ule_mini.png"
                  alt=""
                />
                <div class="text">
                  <p>微信扫描二维码</p>
                  <p>进入小程序</p>
                </div>
              </div>
            </div>
            <div class="floor4">
              <p><span>原汁 原味 原产地</span><span>省钱 省心 邮乐购</span></p>
            </div>
          </li>
          <li class="i1">
            <h4 class="icon-service">产品及服务</h4>
            <div class="a-item">
              <p>
                <a @click="innerHrefOpen('yzg')">邮掌柜</a>
                <a @click="innerHrefOpen('yznp')">邮政农品</a>
                <a @click="innerHrefOpen('ylsc')">邮乐商城</a>
                <a @click="innerHrefOpen('ylxd')">邮乐小店</a>
                <a @click="innerHrefOpen('ylzb')">邮乐直播</a>
              </p>
              <p>
                <a @click="innerHrefOpen('ylyx')">邮乐优鲜</a>
                <a @click="innerHrefOpen('ysh')">邮生活</a>
                <a @click="innerHrefOpen('wlcx')"
                  >物流服务</a
                >
                <a @click="innerHrefOpen('saas')">SAAS服务平台</a>
                <a @click="outerHrefOpen('https://b.ule.com/index.html')"
                  >企业集采</a
                >
              </p>
            </div>
          </li>
          <li class="i2">
            <h4 class="icon-aboutus">关于邮乐</h4>
            <p data-uspm="146">
              <a @click="innerHrefOpen('gsjj')">公司简介</a>
              <a @click="innerHrefOpen('zzjg')">组织架构</a>
              <a @click="innerHrefOpen('fzlc')">发展历程</a>
              <a @click="innerHrefOpen('qywh')">企业文化</a>
              <a @click="outerHrefOpen('https://help.ule.com/helpcenter/index.html')">帮助中心</a>
            </p>
          </li>
          <li class="i3">
            <h4 class="icon-link">快速链接</h4>
            <p data-uspm="146">
              <a target="_blank" href="http://www.chinapost.com.cn/"
                >中国邮政集团官网</a
              >
              <a target="_blank" href="https://www.ems.com.cn/">EMS官网</a>
              <a target="_blank" href="https://www.psbc.com/cn/"
                >邮储银行官网</a
              >
            </p>
          </li>
          <li class="i4">
            <h4 class="icon-tel">联系我们</h4>
            <a>咨询热线（9:00-21:00）</a>
            <h2 class="tel">021-80546588</h2>
          </li>
        </ul>
      </div>
    </div>
    <i class="line"></i>
    <div class="lisence-box">
      <ul class="lisence">
        <!-- <li>
          <span
            ><a
              href="https://i0.ulecdn.com/ule/www/center/wine2023.png?v1.0"
              target="_blank"
              >酒类商品零售许可证：浦市监酒零字 第YB13101150087157-JL号</a
            >
            |
          </span>
        </li> -->
        <li>
          <span
            ><a
              href="https://i1.ulecdn.com/ule/www/center/ybz.jpg?v1.1"
              target="_blank"
              >仅销售预包装食品备案：YB13101150087157</a
            >
            |
          </span>
        </li>
        <li>
          <span
            ><a
              href="https://i1.ulecdn.com/ule/www/center/ypzg.jpg?v1.0"
              target="_blank"
              >互联网药品信息服务资格证编号：(沪)-经营性-2021-0026</a
            >
            |
          </span>
        </li>
        <li>
          <span
            ><a
              href="https://i1.ulecdn.com/ule/www/center/yyzz.jpg?v1.0"
              target="_blank"
              >统一社会信用代码：913100006916203638</a
            ></span
          >
        </li>
        <!-- <li><span><a href="https://i0.ulecdn.com/ule/www/center/tele2023.png" target="_blank">增值电信业务经营许可证：合字B2-20170001</a></span></li> -->
      </ul>
      <ul class="lisence">
        <li>
          <span
            ><a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502009005"
              target="_blank"
              >沪公网安备 31011502009005号</a
            >
            |
          </span>
        </li>
        <li>
          <span
            ><a href="https://beian.miit.gov.cn" target="_blank"
              >沪ICP备 13037728号-1</a
            >
            |
          </span>
        </li>
        <!-- <li>
          <span
            ><a
              href="https://i0.ulecdn.com/ule/www/center/med2023_2.png?v1.0"
              target="_blank"
              >(沪)网械平台备字[2020]第00009号</a
            >
            |
          </span>
        </li> -->
        <li>
          <span
            >Copyright © 2009-2023 上海邮乐网络技术有限公司 ULE.COM
            版权所有</span
          >
        </li>
      </ul>
      <!-- <p class="lisence">
        <span>沪公网安备 31011502009005号 | 沪ICP备 13037728号-1 |
          (沪)网械平台备字[2020]第00009号
        </span>
        <span>Copyright © 2009-2023 上海邮乐网络技术有限公司 ULE.COM 版权所有</span>
      </p> -->
    </div>
    <div class="back-top-box" @click="scrollTop">
      <div class="back-top-box-inner">
        <img
          src="https://i0.ulecdn.com/sites/ule/img/home/new/icon_top.png"
          alt=""
        />
        <p>返回顶部</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  methods: {
    outerHrefOpen(path) {
      window.open(path);
    },
    innerHrefOpen(path) {
      let originName = location.origin;
      path = `${originName}${this.$basePath}/${path}`;
      window.open(path);
    },
    scrollTop() {
      window.scrollTo({
        left: 0,
        top: 0,
        behavior: "smooth"
      });
    }
  }
};
</script>

<style lang="less" scoped>
.footer-module {
  padding-top: 35px;
  font-size: 12px;
  background-color: #fff;
  *zoom: 1;
  clear: both;
  position: relative;
  .footer-box {
    width: 1200px;
    margin: 0 auto;
  }
  .foot-banner {
    display: inline-block;
    height: 90px;
    width: 100%;
    //padding: 17px 0;
    background: url("https://i0.ulecdn.com/sites/ule/img/footer/icon-footer.png")
      no-repeat;
    //background-position: 0 -35px;
    background-position: 0 -125px;
    border-bottom: 1px solid rgba(218, 218, 218, 0.7);
    a {
      float: left;
      height: 52px;
      text-indent: -9999px;
      overflow: hidden;
      cursor: pointer;
      &.foot-banner-post {
        width: 80px;
      }
      &.foot-banner-tom {
        width: 120px;
        margin-left: 20px;
      }
      &.foot-banner-commitment {
        width: 210px;
        margin-left: 30px;
      }
      &.foot-banner-free {
        width: 220px;
        margin-left: 16px;
      }
      &.foot-banner-weibo {
        width: 220px;
        margin-left: 20px;
        display: none;
      }
    }
    span.foot-banner-weibo {
      float: left;
      width: 63px;
      height: 24px;
      padding: 17px 0 0 160px;
      display: none;
    }
  }
  .foot-helper {
    //padding: 10px 0 20px;
    text-align: left;
    overflow: hidden;
    width: 100%;
    position: relative;
    ul {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      //align-items: center;
      li {
        .footer-qr {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          //padding-bottom: 2px;
          img {
            display: block;
            width: 132px;
            height: 132px;
            margin-top: 0;
          }
          p {
            width: 103px;
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 25px;
          }
        }
        .footer-text {
          height: 24px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000;
          line-height: 24px;
        }
        &:nth-of-type(1) {
          margin-right: 73px;
          width: 334px;
          .floor1 {
            .logo-yz {
              width: 91px;
              height: 27px;
            }
            i {
              display: inline-block;
              width: 1px;
              height: 17px;
              background: #ccc;
              margin: 0 10px 2px 13px;
            }
            .logo-ule {
              width: 43px;
              height: 21px;
            }
          }
          .floor2 {
            display: inline-block;
            margin-top: 8px;
            font-size: 12px;
            color: #231716;
            background: #f2f2f2;
            border-radius: 3px;
            padding: 4px 6px;
          }
          .floor3 {
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-top: 19px;
            .img-wraper {
              img {
                width: 96px;
                height: 96px;
              }
              .text {
                margin-top: 3px;
                p {
                  font-size: 12px;
                  color: #666666;
                  line-height: 21px;
                  text-align: center;
                }
              }
            }
          }
          .floor4 {
            margin-top: 15px;
            background: #f2f2f2;
            border-radius: 4px;
            padding: 5px 0;
            text-align: center;
            font-size: 14px;
            font-weight: 400;
            color: #231716;
            line-height: 24px;
            span {
              &:nth-child(2) {
                margin-left: 15px;
              }
            }
          }
        }
        &:nth-of-type(2),
        &:nth-of-type(3),
        &:nth-of-type(4) {
          margin-right: 85px;
        }

        .a-item {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          p {
            &:nth-of-type(2) {
              padding-left: 28px;
            }
          }
        }
        .tel {
          font-size: 22px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 40px;
        }
        // img {
        //   margin-top: 10px;
        // }
        h4 {
          color: #222;
          line-height: 24px;
          font-size: 16px;
          padding-bottom: 14px;
          position: relative;
          &.icon-service {
            &::before {
              content: "";
              background: url("https://i0.ulecdn.com/sites/ule/img/home/new/icon_service.png")
                no-repeat center / 100% 100%;
              width: 24px;
              height: 24px;
              position: absolute;
              left: -28px;
              top: 0;
            }
          }
          &.icon-aboutus {
            &::before {
              content: "";
              background: url("https://i0.ulecdn.com/sites/ule/img/home/new/icon_aboutus.png")
                no-repeat center / 100% 100%;
              width: 24px;
              height: 24px;
              position: absolute;
              left: -28px;
              top: 0;
            }
          }
          &.icon-link {
            &::before {
              content: "";
              background: url("https://i0.ulecdn.com/sites/ule/img/home/new/icon_link.png")
                no-repeat center / 100% 100%;
              width: 24px;
              height: 24px;
              position: absolute;
              left: -28px;
              top: 0;
            }
          }
          &.icon-tel {
            &::before {
              content: "";
              background: url("https://i0.ulecdn.com/sites/ule/img/home/new/icon_tel.png")
                no-repeat center / 100% 100%;
              width: 24px;
              height: 24px;
              position: absolute;
              left: -28px;
              top: 0;
            }
          }
        }
        a {
          display: block;
          font-size: 14px;
          padding-bottom: 10px;
          color: #666;
          strong {
            background: #af0505;
            color: #fff;
            padding: 2px 5px 3px;
          }
        }
      }
    }
  }
  .line {
    margin: 27px auto 0;
    display: block;
    width: 1250px;
    height: 1px;
    background: #f2f2f2;
  }
  .lisence-box {
    width: 1200px;
    margin: 0 auto;
    padding: 10px 0;
  }
  .lisence {
    display: flex;
    justify-content: center;
    padding: 5px 0;
    li {
      font-size: 12px;
      line-height: 20px;
      margin-right: 7px;
      &:nth-last-of-type(1) {
        margin-right: 0px;
      }
      a,
      span {
        color: #999999;
      }
    }
  }

  .back-top-box {
    position: absolute;
    right: 90px;
    top: 160px;
    cursor: pointer;
    .back-top-box-inner {
      img {
        width: 74px;
        height: 74px;
      }
      p {
        font-size: 12px;
        text-align: center;
        font-weight: 400;
        color: #808080;
        line-height: 17px;
        margin-top: -5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/Footer.vue